import { brandSecondary } from '../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	body: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	bodyContent: {
		padding: '36px 20px 16px 20px',
		textAlign: 'center',
	},
	container: {
		width: 400,
	},
	finishButton: {
		// ctaButton is display:flex, which filled the footer when this was an anchor. A button sizes to its
		// content instead, so the width has to be asked for to keep the full-width CTA it has always been.
		width: '100%',
		textDecoration: 'none',
	},
	footer: {
		marginTop: 40,
	},
	header: {
		color: brandSecondary,
		fontSize: 18,
		lineHeight: '22px',
	},
	loading: {},
	subtitle: {
		color: '#858585',
		fontSize: 12,
		marginTop: 14,
	},
	title: {
		color: '#4A4A4A',
		fontSize: 14,
		marginTop: 26,
	},
});
